var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from 'react';
import { Box, IconButton, Stack, Tab, Tabs, Tooltip } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import DynamicForm from './DynamicForm';
import { createInitialFormValues } from './form_validation';
import { hiddenWhenInactiveSx, RECORD_ADD_BUTTON_SX, RECORD_ADD_ICON_SX, RECORD_REMOVE_BUTTON_SX, RECORD_REMOVE_ICON_SX, RECORD_TAB_BAR_SX, RECORD_TAB_STRIP_SX, RECORD_TABS_SX, } from './dynamic_form_styles';
var DEFAULT_MAX_RECORDS = 10;
var RecordFormPanel = React.memo(function (_a) {
    var recordTab = _a.recordTab, recordIndex = _a.recordIndex, isActive = _a.isActive, recordHeader = _a.recordHeader, getSections = _a.getSections, getSectionHeaders = _a.getSectionHeaders, initialOverrides = _a.initialOverrides, deriveValues = _a.deriveValues, actionHandlers = _a.actionHandlers, lookupHandlers = _a.lookupHandlers, searchHandlers = _a.searchHandlers, sectionSlots = _a.sectionSlots, sectionActions = _a.sectionActions, groupActions = _a.groupActions, lockedFieldNames = _a.lockedFieldNames, ocrFilledValues = _a.ocrFilledValues, onFieldChange = _a.onFieldChange, registerFormRef = _a.registerFormRef;
    var sections = React.useMemo(function () { return getSections(recordIndex); }, [getSections, recordIndex]);
    var initialValues = React.useMemo(function () { return createInitialFormValues(sections, initialOverrides); }, [sections, initialOverrides]);
    var sectionHeaders = React.useMemo(function () { return getSectionHeaders === null || getSectionHeaders === void 0 ? void 0 : getSectionHeaders(recordIndex); }, [getSectionHeaders, recordIndex]);
    return (React.createElement(Box, { role: "tabpanel", id: "".concat(recordTab.id, "-panel"), "aria-labelledby": "".concat(recordTab.id, "-tab"), sx: hiddenWhenInactiveSx(isActive) },
        recordHeader,
        React.createElement(DynamicForm, { ref: registerFormRef(recordTab.id), sections: sections, initialValues: initialValues, deriveValues: deriveValues, actionHandlers: actionHandlers, lookupHandlers: lookupHandlers, searchHandlers: searchHandlers, sectionSlots: sectionSlots, sectionActions: sectionActions, groupActions: groupActions, sectionHeaders: sectionHeaders, lockedFieldNames: lockedFieldNames, ocrFilledValues: ocrFilledValues, onFieldChange: onFieldChange })));
});
RecordFormPanel.displayName = 'RecordFormPanel';
var MultiRecordFormTabs = React.forwardRef(function (_a, ref) {
    var idPrefix = _a.idPrefix, getSections = _a.getSections, getRecordLabel = _a.getRecordLabel, addLabel = _a.addLabel, _b = _a.canAddRecords, canAddRecords = _b === void 0 ? true : _b, _c = _a.maxRecords, maxRecords = _c === void 0 ? DEFAULT_MAX_RECORDS : _c, initialOverrides = _a.initialOverrides, deriveValues = _a.deriveValues, actionHandlers = _a.actionHandlers, lookupHandlers = _a.lookupHandlers, searchHandlers = _a.searchHandlers, getSectionSlots = _a.getSectionSlots, getSectionHeaders = _a.getSectionHeaders, getSectionActions = _a.getSectionActions, getGroupActions = _a.getGroupActions, onFieldChange = _a.onFieldChange, getLockedFieldNames = _a.getLockedFieldNames, getOcrFilledValues = _a.getOcrFilledValues, getRecordHeader = _a.getRecordHeader, trailingContent = _a.trailingContent, leadingTabs = _a.leadingTabs, _d = _a.initialRecordCount, initialRecordCount = _d === void 0 ? 1 : _d, _e = _a.isPrimaryRemovable, isPrimaryRemovable = _e === void 0 ? false : _e, onRemoveLastRecord = _a.onRemoveLastRecord, onActiveRecordChange = _a.onActiveRecordChange, confirmRemoveRecord = _a.confirmRemoveRecord, onRecordRemoved = _a.onRecordRemoved;
    var readOnlyTabs = React.useMemo(function () { return leadingTabs !== null && leadingTabs !== void 0 ? leadingTabs : []; }, [leadingTabs]);
    var _f = React.useState(function () {
        return Array.from({ length: Math.max(initialRecordCount, 0) }, function (_unused, index) { return index; });
    }), recordKeys = _f[0], setRecordKeys = _f[1];
    var _g = React.useState(0), activeRecordIndex = _g[0], setActiveRecordIndex = _g[1];
    var _h = React.useState(new Set()), invalidRecordIndexes = _h[0], setInvalidRecordIndexes = _h[1];
    React.useEffect(function () {
        onActiveRecordChange === null || onActiveRecordChange === void 0 ? void 0 : onActiveRecordChange(activeRecordIndex);
    }, [activeRecordIndex, onActiveRecordChange]);
    var _j = React.useState(function () {
        return initialRecordCount > 0 ? null : 0;
    }), activeLeadingIndex = _j[0], setActiveLeadingIndex = _j[1];
    var nextRecordKeyRef = React.useRef(Math.max(initialRecordCount, 1));
    var recordId = React.useCallback(function (uniqueKey) { return "".concat(idPrefix, "-").concat(uniqueKey); }, [idPrefix]);
    var formHandlesRef = React.useRef(new Map());
    var recordTabs = React.useMemo(function () {
        return recordKeys.map(function (uniqueKey, recordIndex) { return ({
            id: recordId(uniqueKey),
            label: getRecordLabel(recordIndex),
        }); });
    }, [getRecordLabel, recordId, recordKeys]);
    var formRefSettersRef = React.useRef(new Map());
    var registerFormRef = React.useCallback(function (panelId) {
        var cachedSetter = formRefSettersRef.current.get(panelId);
        if (cachedSetter) {
            return cachedSetter;
        }
        var setter = function (handle) {
            if (handle) {
                formHandlesRef.current.set(panelId, handle);
            }
            else {
                formHandlesRef.current.delete(panelId);
            }
        };
        formRefSettersRef.current.set(panelId, setter);
        return setter;
    }, []);
    var recordKeysRef = React.useRef(recordKeys);
    recordKeysRef.current = recordKeys;
    var maxRecordsRef = React.useRef(maxRecords);
    maxRecordsRef.current = maxRecords;
    var orderedHandles = React.useCallback(function () {
        return recordKeysRef.current.map(function (uniqueKey) { var _a; return (_a = formHandlesRef.current.get(recordId(uniqueKey))) !== null && _a !== void 0 ? _a : null; });
    }, [recordId]);
    var handleAt = React.useCallback(function (recordIndex) {
        var _a;
        var uniqueKey = recordKeysRef.current[recordIndex];
        return uniqueKey === undefined
            ? null
            : (_a = formHandlesRef.current.get(recordId(uniqueKey))) !== null && _a !== void 0 ? _a : null;
    }, [recordId]);
    var handleAddRecord = React.useCallback(function () {
        var currentKeys = recordKeysRef.current;
        if (currentKeys.length >= maxRecordsRef.current) {
            return;
        }
        setRecordKeys(__spreadArray(__spreadArray([], currentKeys, true), [nextRecordKeyRef.current], false));
        nextRecordKeyRef.current += 1;
        setActiveRecordIndex(currentKeys.length);
        setActiveLeadingIndex(null);
        setInvalidRecordIndexes(new Set());
    }, []);
    var onRemoveLastRecordRef = React.useRef(onRemoveLastRecord);
    onRemoveLastRecordRef.current = onRemoveLastRecord;
    var readOnlyTabsRef = React.useRef(readOnlyTabs);
    readOnlyTabsRef.current = readOnlyTabs;
    var confirmRemoveRecordRef = React.useRef(confirmRemoveRecord);
    confirmRemoveRecordRef.current = confirmRemoveRecord;
    var onRecordRemovedRef = React.useRef(onRecordRemoved);
    onRecordRemovedRef.current = onRecordRemoved;
    var handleRemoveRecord = React.useCallback(function (recordIndex) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, currentKeys;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _a = confirmRemoveRecordRef.current;
                    if (!_a) return [3, 2];
                    return [4, confirmRemoveRecordRef.current(recordIndex)];
                case 1:
                    _a = !(_d.sent());
                    _d.label = 2;
                case 2:
                    if (_a) {
                        return [2];
                    }
                    currentKeys = recordKeysRef.current;
                    if (currentKeys.length === 1 && readOnlyTabsRef.current.length === 0) {
                        (_b = onRemoveLastRecordRef.current) === null || _b === void 0 ? void 0 : _b.call(onRemoveLastRecordRef);
                        return [2];
                    }
                    formRefSettersRef.current.delete(recordId(currentKeys[recordIndex]));
                    setRecordKeys(currentKeys.filter(function (_key, index) { return index !== recordIndex; }));
                    (_c = onRecordRemovedRef.current) === null || _c === void 0 ? void 0 : _c.call(onRecordRemovedRef, recordIndex);
                    setActiveRecordIndex(function (previousIndex) {
                        return previousIndex > recordIndex
                            ? previousIndex - 1
                            : Math.max(Math.min(previousIndex, currentKeys.length - 2), 0);
                    });
                    if (currentKeys.length === 1) {
                        setActiveLeadingIndex(0);
                    }
                    setInvalidRecordIndexes(new Set());
                    return [2];
            }
        });
    }); }, [recordId]);
    React.useImperativeHandle(ref, function () { return ({
        validate: function () {
            var results = orderedHandles().map(function (handle) { var _a; return (_a = handle === null || handle === void 0 ? void 0 : handle.validate()) !== null && _a !== void 0 ? _a : true; });
            setInvalidRecordIndexes(new Set(results.reduce(function (indexes, isValid, index) {
                if (!isValid) {
                    indexes.push(index);
                }
                return indexes;
            }, [])));
            var firstInvalidIndex = results.findIndex(function (isValid) { return !isValid; });
            if (firstInvalidIndex >= 0) {
                setActiveRecordIndex(firstInvalidIndex);
                setActiveLeadingIndex(null);
                return false;
            }
            return true;
        },
        getRecords: function () {
            return orderedHandles()
                .filter(function (handle) { return Boolean(handle); })
                .map(function (handle) { return handle.getValues(); });
        },
        getFiles: function () {
            return orderedHandles().reduce(function (files, handle, recordIndex) {
                var _a;
                Object.entries((_a = handle === null || handle === void 0 ? void 0 : handle.getFiles()) !== null && _a !== void 0 ? _a : {}).forEach(function (_a) {
                    var fieldName = _a[0], file = _a[1];
                    files["".concat(idPrefix, "-").concat(recordIndex, "-").concat(fieldName)] = file;
                });
                return files;
            }, {});
        },
        reset: function () { return orderedHandles().forEach(function (handle) { return handle === null || handle === void 0 ? void 0 : handle.reset(); }); },
        resetRecord: function (recordIndex) { var _a; return (_a = handleAt(recordIndex)) === null || _a === void 0 ? void 0 : _a.reset(); },
        mergeActiveRecord: function (partialValues) { var _a; return (_a = handleAt(activeRecordIndex)) === null || _a === void 0 ? void 0 : _a.mergeValues(partialValues); },
        mergeRecord: function (recordIndex, partialValues) { var _a; return (_a = handleAt(recordIndex)) === null || _a === void 0 ? void 0 : _a.mergeValues(partialValues); },
        getActiveRecordIndex: function () { return activeRecordIndex; },
    }); }, [activeRecordIndex, handleAt, idPrefix, orderedHandles]);
    var handleTabChange = React.useCallback(function (_event, nextIndex) {
        if (nextIndex < readOnlyTabsRef.current.length) {
            setActiveLeadingIndex(nextIndex);
            return;
        }
        setActiveLeadingIndex(null);
        setActiveRecordIndex(nextIndex - readOnlyTabsRef.current.length);
    }, []);
    var activeTabIndex = activeLeadingIndex !== null
        ? activeLeadingIndex
        : readOnlyTabs.length + activeRecordIndex;
    var canRemove = function (recordIndex) {
        return recordKeys.length > 1
            ? recordIndex > 0 || isPrimaryRemovable
            :
                isPrimaryRemovable &&
                    (readOnlyTabs.length > 0 || Boolean(onRemoveLastRecord));
    };
    return (React.createElement(Box, null,
        React.createElement(Stack, { direction: { xs: 'column', sm: 'row' }, alignItems: { xs: 'stretch', sm: 'center' }, justifyContent: "space-between", gap: 1, sx: RECORD_TAB_BAR_SX },
            React.createElement(Stack, { direction: "row", alignItems: "center", gap: 1, sx: RECORD_TAB_STRIP_SX },
                React.createElement(Tabs, { value: activeTabIndex, onChange: handleTabChange, variant: "scrollable", scrollButtons: "auto", "aria-label": addLabel, sx: RECORD_TABS_SX },
                    readOnlyTabs.map(function (readOnlyTab) { return (React.createElement(Tab, { key: readOnlyTab.id, id: "".concat(readOnlyTab.id, "-tab"), "aria-controls": "".concat(readOnlyTab.id, "-panel"), label: readOnlyTab.label })); }),
                    recordTabs.map(function (recordTab, recordIndex) { return (React.createElement(Tab, { key: recordTab.id, id: "".concat(recordTab.id, "-tab"), "aria-controls": "".concat(recordTab.id, "-panel"), label: React.createElement(Stack, { direction: "row", alignItems: "center", gap: 0.5 },
                            recordTab.label,
                            invalidRecordIndexes.has(recordIndex) && (React.createElement(Tooltip, { title: "Some fields need attention", arrow: true },
                                React.createElement(ErrorOutlineIcon, { color: "error", sx: { fontSize: 16 } }))),
                            canRemove(recordIndex) && (React.createElement(Tooltip, { title: "Remove ".concat(recordTab.label), arrow: true },
                                React.createElement(IconButton, { component: "span", size: "small", "aria-label": "Remove ".concat(recordTab.label), onClick: function (event) {
                                        event.stopPropagation();
                                        handleRemoveRecord(recordIndex);
                                    }, sx: RECORD_REMOVE_BUTTON_SX },
                                    React.createElement(DeleteOutlineIcon, { sx: RECORD_REMOVE_ICON_SX }))))) })); })),
                canAddRecords && (React.createElement(Box, { component: "button", type: "button", onClick: handleAddRecord, disabled: recordKeys.length >= maxRecords, sx: RECORD_ADD_BUTTON_SX },
                    React.createElement(AddIcon, { sx: RECORD_ADD_ICON_SX }),
                    addLabel))),
            trailingContent),
        readOnlyTabs.map(function (readOnlyTab, leadingIndex) { return (React.createElement(Box, { key: readOnlyTab.id, role: "tabpanel", id: "".concat(readOnlyTab.id, "-panel"), "aria-labelledby": "".concat(readOnlyTab.id, "-tab"), hidden: activeLeadingIndex !== leadingIndex }, activeLeadingIndex === leadingIndex && readOnlyTab.content)); }),
        recordTabs.map(function (recordTab, recordIndex) { return (React.createElement(RecordFormPanel, { key: recordTab.id, recordTab: recordTab, recordIndex: recordIndex, isActive: activeLeadingIndex === null && recordIndex === activeRecordIndex, getSections: getSections, getSectionHeaders: getSectionHeaders, initialOverrides: initialOverrides, deriveValues: deriveValues, actionHandlers: actionHandlers, lookupHandlers: lookupHandlers, searchHandlers: searchHandlers, recordHeader: getRecordHeader === null || getRecordHeader === void 0 ? void 0 : getRecordHeader(recordIndex), sectionSlots: getSectionSlots === null || getSectionSlots === void 0 ? void 0 : getSectionSlots(recordIndex), sectionActions: getSectionActions === null || getSectionActions === void 0 ? void 0 : getSectionActions(recordIndex), groupActions: getGroupActions === null || getGroupActions === void 0 ? void 0 : getGroupActions(recordIndex), lockedFieldNames: getLockedFieldNames === null || getLockedFieldNames === void 0 ? void 0 : getLockedFieldNames(recordIndex), ocrFilledValues: getOcrFilledValues === null || getOcrFilledValues === void 0 ? void 0 : getOcrFilledValues(recordIndex), onFieldChange: onFieldChange &&
                (function (name, value) { return onFieldChange(recordIndex, name, value); }), registerFormRef: registerFormRef })); })));
});
MultiRecordFormTabs.displayName = 'MultiRecordFormTabs';
export default MultiRecordFormTabs;
